import React, { useState, useEffect } from 'react';
import { User } from 'oidc-client';
import { UserProfileProvider } from './UserProfileProvider';

import _ from 'lodash';
interface UserProfileProviderProps {
	authenticatedUser: User;
	children: React.ReactElement | React.ReactElement[];
}

const UserProfileLoader = ({ authenticatedUser, children }: UserProfileProviderProps) => {
	return (
		<UserProfileProvider b2cId={authenticatedUser.profile.sub} token={authenticatedUser.id_token}>
			{children}
		</UserProfileProvider>
	);
};

export default UserProfileLoader;
